import axios from 'axios'
import store from '@/store'
import router from '../router'
import { MessageBox, Message } from 'element-ui'
import NProgress from 'nprogress'
import { getToken, getTid, setTid, getSid, setSid } from '@/utils/cookies'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    timeout: 50000000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    (config) => {
        if (getToken()) {
            config.headers['Authorization'] = getToken()
        }
        config.headers['Accept'] = 'application/json'
        NProgress.start()
        return config
    },
    (error) => {
        console.log(error)
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    (response) => {
        NProgress.done()
        const res = response.data

        if (res.code !== 200) {
            if (res.code === 401) {
                const tid = router.history.current.query.tid
                    ? router.history.current.query.tid
                    : getTid()
                tid ? setTid(tid) : ''
                console.log('tid', tid)
                const sid = router.history.current.query.sid
                    ? router.history.current.query.sid
                    : getSid()
                sid ? setSid(sid) : ''

                MessageBox.confirm('请先登录', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('user/resetToken').then(() => {
                        // eslint-disable-next-line object-curly-spacing

                        const _query = {}
                        tid ? (_query.tid = tid) : ''
                        sid ? (_query.sid = sid) : ''

                        router.push({ path: '/login', query: _query })
                    })
                })
            } else {
                Message({
                    message: res.message || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })
            }
            return Promise.reject(new Error(res.message || 'Error'))
        } else {
            return res
        }
    },
    (error) => {
        console.log('error', error) // for debug
        if (error.response) {
            // 登录有问题 后端不返回401，直接报错
            Message({
                message: error.response.data.message,
                type: 'error',
                duration: 5 * 1000
            })
        } else {
            Message({
                message: error.response.data.message,
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service
